import React from "react";
import { cn } from "../../utils/cn";

// A compact native <select> for a control that sits inside a row (a ToggleSwitch's `trailing`),
// where the full `Select` is too tall and its label block does not belong.
//
// The browser's own arrow, deliberately. Suppressing it with `appearance-none` and drawing a
// lucide chevron instead (what `components/ui/Select.jsx` does) rendered TWO arrows in both
// Chrome and Firefox, so the suppression is not reliable here; `pr-8` reserves room for the
// native one instead, which is what stops it landing on top of a long label like
// "Unclassified". One arrow, drawn by whoever is right about where it goes.
//
// `cn` (tailwind-merge), not a template string: `compact` sets a width and a caller may need a
// wider one for long option text. Concatenated, both survive and the stylesheet's order decides
// which wins; merged, the caller's wins because it comes last.
const Picker = ({ value, onChange, disabled, compact, label, className, children }) => (
  <select
    aria-label={label}
    className={cn(
      "flex-shrink-0 rounded-md border border-input bg-background pl-2 pr-8 disabled:opacity-50",
      compact ? "h-8 w-40 text-xs" : "h-10 w-44 text-sm",
      className
    )}
    value={value}
    disabled={disabled}
    onChange={onChange}
  >
    {children}
  </select>
);

export { Picker };
export default Picker;
